<template>
  <div>
    <Multiselect
      v-model="value"
      :options="brandModels"
      :show-labels="false"
      :placeholder="placeholder"
      track-by="model"
      label="modelUppercase"
      open-direction="bottom"
      :disabled="isDisabled"
    >
      <span slot="caret" class="icon-left">
        <Icon icon-name="car">
          <CarIcon></CarIcon>
        </Icon>
      </span>
      <span slot="caret" class="arrow">
        <Icon icon-name="modelsCaret" width="16" height="16" direction="up">
          <Arrow></Arrow>
        </Icon>
      </span>
    </Multiselect>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect'
import Icon from '@/components/shared/Icons/Icon'
import Arrow from '@/components/shared/Icons/arrow.svg'
import CarIcon from '@/components/shared/Icons/car.svg'
export default {
  name: 'ModelsSelect',
  components: {
    Multiselect,
    Icon,
    CarIcon,
    Arrow,
  },
  props: {
    brandModels: { type: Array, default: () => [] },
    placeholder: { type: String },
    selectedModel: { type: Object },
    selectModel: { type: Function, default: () => {} },
    isLoading: { type: Boolean, default: false },
    isDisabled: { type: Boolean, default: false },
  },
  computed: {
    value: {
      // VUE MULTISELECT DOESNT DISPLAY PLACEHOLDER
      // IF EMPTY VALUE IS !== []
      get() {
        return this.selectedModel && this.selectedModel.id
          ? this.selectedModel
          : []
      },
      set(model) {
        this.selectModel(model)
      },
    },
  },

  methods: {},
}
</script>
